import '@roo/roo/theme/default.min.css';

// machproJsCssBabelPlugin插件非自动引入index.css模式时，需要手动引入次文件，手动引入是兼容自动的
import './index.h5.css';
